module.exports = __webpack_public_path__ + "img/telecom.e763ab4f.jpg";